export const API_BASE = process.env.REACT_APP_API_BASE || (process.env.NODE_ENV === 'development' ? 'http://localhost:3002/api' : '/.netlify/functions/api')

// Photo Distribution backend (photo_distribution project): AWS HTTP API Gateway + CloudFront.
// Override via REACT_APP_PHOTO_DIST_API_BASE / REACT_APP_PHOTO_DIST_CF_ROOT on the build.
export const PHOTO_DIST_API_BASE = process.env.REACT_APP_PHOTO_DIST_API_BASE || 'https://f7caoyl7b5.execute-api.eu-central-1.amazonaws.com/prod'
export const PHOTO_DIST_CF_ROOT = process.env.REACT_APP_PHOTO_DIST_CF_ROOT || 'https://djlfytksu75m8.cloudfront.net'
export const PHOTO_DIST_ORG = process.env.REACT_APP_PHOTO_DIST_ORG || 'peakssports'
